import { NgModule } from '@angular/core';
import { CheckPermissionsDirective } from './check-permission-directive';
import {CommonModule} from "@angular/common";

@NgModule({
  imports: [CommonModule],
  declarations: [CheckPermissionsDirective],
  exports: [CheckPermissionsDirective]
})
export class CheckPermissionsDirectiveModule { }